const trashMessages = {
  'trash.headerNotice':
    '最近削除した項目を表示しています。削除日から30日経過したデータは自動的に削除されていきます。',
  'trash.title.arrow': '<',
  'trash.title': '最近削除した項目',
  'trash.media.title': '最近削除した項目 / データ詳細',
};

export default trashMessages;
